import React from "react";


const NotAuthorized = () => {
  return (
    <div>You are not authorized to view this resource. If you believe this is an error, please contact the system administrator.</div>
  );
}

export default NotAuthorized;